// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HamburgerMenu_wrapper__zBA0S","container":"HamburgerMenu_container__1WwSc","dappLink":"HamburgerMenu_dappLink__2MBa9","listElement":"HamburgerMenu_listElement__17ZfJ"};